type PieLayerDimensions = {
    centerX: number;
    centerY: number;
    innerRadius: number;
    radius: number;
};

const clamp = (value: number, min: number, max: number) => Math.min(Math.max(value, min), max);

const estimateSvgTextWidth = (value: string, fontSize: number) => value.length * fontSize * 0.58;

export const getCenterMetricTextLayout = (
    dimensions: PieLayerDimensions,
    value: string,
    options: { maxFontSize?: number; minFontSize?: number } = {},
) => {
    const shortestSide = Math.max(1, dimensions.radius * 2);
    const availableWidth = Math.max(48, (dimensions.innerRadius || dimensions.radius) * 1.5);
    const maxFontSize = options.maxFontSize ?? clamp(shortestSide * 0.18, 18, 40);
    const minFontSize = options.minFontSize ?? 10;
    const fontSizeByLength = availableWidth / Math.max(value.length * 0.58, 1);
    const valueFontSize = clamp(Math.min(maxFontSize, fontSizeByLength), minFontSize, maxFontSize);
    const labelFontSize = clamp(valueFontSize * 0.4, 9, 14);
    const gap = clamp(shortestSide * 0.035, 4, 12);
    const estimatedValueWidth = estimateSvgTextWidth(value, valueFontSize);

    return {
        labelFontSize,
        labelY: dimensions.centerY + valueFontSize * 0.55 + gap,
        valueFontSize,
        valueTextFit:
            estimatedValueWidth > availableWidth
                ? ({
                      lengthAdjust: 'spacingAndGlyphs' as const,
                      textLength: availableWidth,
                  } as const)
                : {},
        valueY: dimensions.centerY - labelFontSize * 0.5 - gap,
    };
};
